















































import { Component, Vue, Watch } from 'vue-property-decorator'
import { Action, Mutation } from 'vuex-class'
import { mapState, mapMutations, mapActions } from 'vuex'

@Component({
  computed: {
    ...mapState({
      sidebar: ({ gamblingContext }: any) => gamblingContext.sidebar,
      isAuthenticated: ({ gamblingContext }: any) => gamblingContext.isAuthenticated,
      pageLayoutOptions: ({ gamblingContext }: any) => gamblingContext.pageLayoutOptions,
      pageLayout: ({ gamblingContext }: any) => gamblingContext.pageLayout
    })
  }
})
export default class Sidebar extends Vue {
  @Action('logout') logout: any
  @Action('reloadCashier') reloadCashier: any
  @Mutation('setSidebar') setSidebar: any
  @Mutation('setPageLayout') setPageLayout: any
  @Mutation('setAccountType') setAccountType: any

  sidebar!: boolean
  authNav: object[] = [
    {
      name: 'Account',
      path: '/gambling/account/######/',
      icon: 'mdi-account',
      action: 'account'
    },
    {
      name: 'Deposit',
      path: '/gambling/account/##/',
      icon: 'mdi-cash',
      action: 'deposit'
    },
    {
      name: 'Transactions',
      path: '/gambling/account/###/',
      icon: 'mdi-cash',
      action: 'transactions'
    },
    {
      name: 'Logout',
      path: '/gambling/####/',
      icon: 'mdi-logout',
      action: 'logout'
    }
  ]
  navigation: object[] = [
    {
      name: 'Home',
      path: '/gambling/#/',
      icon: 'mdi-view-dashboard'
    },
    // {
    //   name: 'Casino',
    //   path: '/gambling/casino',
    //   icon: 'mdi-dice-6'
    // },
    // {
    //   name: 'Betting',
    //   path: '/gambling/betting',
    //   icon: 'mdi-football'
    // }
  ]
  pageLayout!: string
  pageLayoutOptions!: string[]
  $routeChange!: any
  $cashierConfigs!: any
  $smallScreen!: boolean

  get showSideBar () {
    return this.$smallScreen || this.pageLayout === 'layout4'
  }

  get getSetPageLayout () {
    return this.pageLayout
  }
  set getSetPageLayout (layout: string) {
    this.setPageLayout(layout)
  }

  get getSidebar () {
    return this.sidebar
  }
  set getSidebar (val: boolean) {
    this.setSidebar(val)
  }

  clickAction (action: string, path: string): void {
    switch (action) {
      case 'logout':
        this.logout()
        break
      case 'deposit':
        this.reloadCashier({method: 'deposit', transactionsOnly: false})
        this.setAccountType('banking')
        this.$routeChange(path)
        break
      case 'account':
        this.setAccountType('account')
        this.$routeChange(path)
        break
      case 'transactions':
        this.$cashierConfigs('transactions', { tabs: false })
        this.setAccountType('history')
        this.$routeChange(path)
        break
    }
  }
}
